<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';

interface Props {
  currentStep?: number;
  totalSteps?: number;
  class?: HTMLAttributes['class'];
}

const props = withDefaults(defineProps<Props>(), {
  currentStep: 1,
  totalSteps: 4,
});
</script>

<template>
  <div :class="cn('tw-flex tw-items-center tw-justify-between', props.class)">
    <slot />
  </div>
</template>
